<template>
  <v-dialog
    v-model="visibility"
    max-width="500"
    persistent
  >
    <v-card class="px-2 py-2">
      <v-card-title class="headline py-2 pr-2">
        Zablokuj konto <span class="hidden-xs-only">&nbsp;klienta</span>
        <v-spacer></v-spacer>
        <v-btn
          @click.native="visibility = false"
          icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        Czy na pewno chcesz zablokować konto Klienta?
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          color="primary lighten-2"
          flat="flat"
          @click="setVisbility"
        >
          Anuluj
        </v-btn>

        <v-btn
          color="primary"
          :loading="busy"
          :disabled="busy"
          @click="lock"
        >
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'client-lock-dialog',
  data: () => ({
    busy: false,
  }),
  computed: {
    ...mapGetters('clients', [
      'dialogVisibility',
    ]),
    clientId() {
      return this.dialogVisibility.id;
    },
    visibility: {
      get() {
        return this.dialogVisibility.type === 'lock';
      },
      set(val) {
        this.setDialogVisbility(val);
      },
    },
  },
  methods: {
    ...mapActions('clients', [
      'setDialogVisbility',
      'lockClient',
    ]),
    setVisbility() {
      this.setDialogVisbility(false);
    },
    async lock() {
      this.busy = true;
      await this.lockClient(this.clientId);
      this.busy = false;
      this.setDialogVisbility(false);
    },
  },
};
</script>
